<template>
  <div>Offer include</div>
</template>

<script>
export default {};
</script>

<style>
</style>